import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../base-components/pai-button';

interface Props {
  open: boolean;
  title?: string;
  content: string;

  handleConfirm(): void;
}

const PaiSuccessDialog: React.FC<Props> = ({ open, title, content, handleConfirm }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      {!_.isNil(title) ? (
        <DialogTitle className={classes.title}>
          <Typography className={classes.titleText}>{title}</Typography>
        </DialogTitle>
      ) : null}
      <DialogContent className={classes.content}>
        <Typography className={classes.text}>{content}</Typography>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiButton text={t('ok')} action={handleConfirm} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  title: {
    background: theme.palette.primary.main,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
  },
  text: {
    fontSize: theme.typography.pxToRem(13),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default PaiSuccessDialog;
